import { Combo } from "./combo"
export class PromoCombo {
   /**
    * 
    * @param {Combo} combo_1 
    * @param {Combo} combo_2 
    */
   constructor (combo_1, combo_2){
      this.combo_1 = combo_1
      this.combo_2 = combo_2
   }

   tipoProductoParticipante_1(){
      if(this.combo_1){
         return this.combo_1.type;
      }
      return null;
   }

   tipoProductoParticipante_2(){
      if(this.combo_2){
         return this.combo_2.type;
      }
      return null;
   }
   
   descripcion_1(){
      if(this.combo_1){
         return this.combo_1.descripcion();
      }
   }

   descripcion_2(){
      if(this.combo_2){
         return this.combo_2.descripcion();
      }
   }

   static fromServiceCombo(combo){
      const c1 = new Combo(
         combo.ID_Promocion,
         combo.Tipo_1,
         combo.ID_Producto_1,
         combo.Nm_Producto_1,
         combo.Cantidad_1,
         combo.ID_Linea_1,
         combo.Nm_Linea_1,
         combo.ID_Presentacion_1,
         combo.Nm_Presentacion_1,
         combo.Productos_Participantes_String_1
      );

      const c2 = new Combo(
         combo.ID_Promocion,
         combo.Tipo_2,
         combo.ID_Producto_2,
         combo.Nm_Producto_2,
         combo.Cantidad_2,
         combo.ID_Linea_2,
         combo.Nm_Linea_2,
         combo.ID_Presentacion_2,
         combo.Nm_Presentacion_2,
         combo.Productos_Participantes_String_2
      );

      return new PromoCombo(c1, c2);
   }
}